<template>
  <div class="main-content">
    <section class="section">
      <PageHeaderNoAction></PageHeaderNoAction>
      <div class="section-body">
        <div class="card">
          <div class="card-header">
            <h4>Create User</h4>
          </div>
          <div class="card-body">
            <form>
              <div class="form-group">
                <div class="row">
                <div class="col-6">
                  <label >Last Name</label>
              <input type="text"  class="form-control" v-model="last_name" required/>
                </div>
                <div class="col-6">
                  <label >First Name</label>
              <input type="text"  class="form-control" v-model="first_name" required/>
            </div>
                </div>
                </div>
            <div class="form-group">
              <label >Position</label>
              <input type="text" class="form-control" v-model="position" required/>
            </div>
              <div class="form-group">
              <label >User Name</label>
              <input type="text" ref="cusername" class="form-control" v-model="username" @blur="checkusernameexist()" required />
              <div class="errormsg" v-if="usernamecannotuse">User Name already exist</div>
              <div class="errormsg" v-if="haveSpecialCharacters">User Name cannot have Special Characters</div>
              <div class="correctname" v-if="usernamecanuse">You can use this User Name</div>
            </div>
            <div class="form-group">
              <label >Password</label>
              <input type="password" ref="cpassword" class="form-control" v-model="password" required />
            </div>
             <div class="form-group">
              <label >Confirm Password</label>
              <input type="password" ref="checkpassword" class="form-control" v-model="confirmpassword" required />
            </div>
            <div class="form-group">
              <label >Email address</label>
              <input type="email" class="form-control"  aria-describedby="emailHelp" v-model="email" required >
              <small id="emailHelp" class="form-text text-muted"></small>
            </div>
            <button class="btn btn-primary" @click="createbtn()">Create User</button>
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import Vue from "vue";
import api from "@/api";
import config from "@/config";
import helper from "@/vueHelper";

export default {
  title: "Create user",
  access_code: "G_USER",
  hidden: true,
  data() {
    return {
      username: "",
      password: "",
      confirmpassword: "",
      email: "",
      first_name:"",
      last_name:"",
      position:"",
      haveSpecialCharacters:false,
      usernamecannotuse:false,
      usernamecanuse:false
    };
  },
  components: {},
  methods:{
      createbtn(){
        if(this.password != this.confirmpassword ){
              alert("The password is not same");
          }else if(!this.username && !this.password && !this.email && !this.first_name && !this.last_name && !this.position){

          }else if(this.usernamecanuse==true && this.email.includes("@")){
          api.request(
          this,
          "post",
          "/system/createuser",
          {
            SessionID: helper.getSessionID(),
            LocaleCode: helper.getLocaleCode(),
            Parameters: {
              username:this.username,
              password:this.password,
              first_name:this.first_name,
              last_name:this.last_name,
              email:this.email,
              position:this.position
            }
          },

          function(r) {
            if(r.data.success="success"){
                this.$router.push("/SystemMaintenance/User/");
            }
          });
          }
      },
      checkusernameexist(){
        if(!this.username){
          
        }else if(this.containsSpecialCharacters(this.username)==true){
          this.haveSpecialCharacters=true;
        }else if(this.containsSpecialCharacters(this.username)==false){
          var vm=this;
          $.ajax({
             type: "POST",
             url: config.serverURI + '/api/system/checkusernameexist',
             headers: {
                    "Content-type": "application/json; charset=utf-8"
                  },
             data: JSON.stringify(
                {
                      SessionID: helper.getSessionID(),
                      LocaleCode: helper.getLocaleCode(),
                      Parameters: {
                        username:this.username,
                      },
                      ApiKey: config.apiKey,
                      ApiSystemName: config.apiSystemName
                    }
              ),
             dataType:"json",
             success: function(r) {
            var userstatus=r.data.userstatus;
            if(userstatus=="alreadyhave"){
              vm.usernamecannotuse= true;
              vm.usernamecanuse=false;
              vm.haveSpecialCharacters=false;
            }else if(userstatus=="nouser"){
              vm.usernamecanuse= true;
              vm.usernamecannotuse=false;
              vm.haveSpecialCharacters=false;
            }
             }
          });
         }
       },
      containsSpecialCharacters(str){
          var regex = /[ !@#$%^&*()+\-=\[\]{};':"\\|,<>\/?]/g;
        	return regex.test(str);
        }
  }
};
</script>
<style >
.section-body {
  padding-top: 100px;
}
.errormsg {
  width: 100%;
    margin-top: .25rem;
    font-size: 80%;
    color: #dc3545;
}
.correctname {
  width: 100%;
    margin-top: .25rem;
    font-size: 80%;
    color: #22b60e;
}
</style>